<template>
  <div>
    <div class="heading">Filters</div>
    <div id="sidebar-desktop">
      <Filters></Filters>
    </div>
  </div>
</template>

<script>
import Filters from "@/components/Filters.vue";

export default {
  name: "sidebar-desktop",
  components: {
    Filters
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

#sidebar-desktop {
  background: $light;
  padding: $standard-padding;
  padding-top: 1.5em;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
  width: 100%;
  min-height: 500px;
}

.heading {
  background: $gradient-color;
  color: white;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;
  text-align: center;
  padding: 0.75em;
}

.tool-bar__order-by {
  background: $light;
  width: 100%;
  cursor: pointer;
  padding: 0.3em;
  margin-bottom: 0.75em;
  text-align: center;
  border: solid 1px #919191;
  border-radius: 8px;
}
.order-dropdown {
  position: absolute;
  width: 158px;
  margin-top: 8px;
  z-index: 102;
  margin-left: -6px !important;
  border: solid 1px #919191;
  border-radius: 3px;
  background: white;
  * + * {
    border-top: 1px dashed $primary-dark;
  }
  .order-dropdown-item {
    padding: 0.6em 0.3em;
    margin: 0;
    cursor: pointer;
  }
  .order-dropdown-item:hover {
    background: $secondary-color;
  }
}
</style>